/* Built In Imports */
import React from 'react';
/* External Imports */

import { Box, Flex, Text } from '@chakra-ui/react';
/* Internal Imports */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import config from '@config';
import MsrSectionTitle from '@msr/components/Headings/MsrSectionTitle';

/**
 *
 * @param {Object} sectionContent
 * @returns
 */
const HowItWorks = ({ sectionContent, lang, region }) => {
  // Extract the title and cards from sectionContent
  const sectionTitle = sectionContent[0];
  const cards = sectionContent[1]?.cards || [];

  return (
    <Box pt={{ md: '5rem' }} pb={{ base: '2rem', md: '8rem' }}>
      <Flex justifyContent={'space-between'} mt={{ md: '-5rem' }}>
        <Box
          width={{ base: '136px', md: '469px' }}
          height={{ base: '31px', md: '107px' }}
        >
          <LazyLoadImageComponent
            src={`${config.staticPath}/d/46272/1739778629-pngwing-com-2.png`}
            height={'100%'}
            width={'100%'}
          />
        </Box>
        <Box
          width={{ base: '136px', md: '469px' }}
          height={{ base: '31px', md: '107px' }}
        >
          <LazyLoadImageComponent
            src={`${config.staticPath}/d/46272/1739778629-pngwing-com-2.png`}
            height={'100%'}
            width={'100%'}
          />
        </Box>
      </Flex>

      {/* Section Title */}
      <MsrSectionTitle titleObj={sectionTitle} lang={lang} maxwidth="582px" />

      {/* Map over the cards */}
      <Flex
        gap={{ base: '3.5rem', md: '3rem' }}
        px={{ base: '2rem' }}
        flexWrap={{ md: 'wrap', xl: 'nowrap' }}
        mx="auto"
        flexDir={{ base: 'column', md: 'row' }}
        justifyContent={{ base: 'center' }}
        mt={{ base: '4rem', md: '4.5rem' }}
      >
        {cards.map((card, index) => (
          <Flex
            key={index}
            flexDir="column"
            alignItems="center"
            gap={{ base: '1rem', md: '1.5rem' }}
            maxW={{ md: '317px' }}
          >
            <Box
              width={{ base: '100px', md: '100px' }}
              height={{ base: 'auto', md: '70px' }}
              mx="auto"
            >
              <LazyLoadImageComponent
                width={{ base: 'auto', md: '100%' }}
                height={{ base: 'auto', md: '100%' }}
                objectFit={{ base: 'cover', md: 'contain' }}
                objectPosition={{ md: 'center' }}
                src={card.thumbnail?.url}
                alt={card.thumbnail?.alt || 'Card Thumbnail'}
              />
            </Box>

            <Text
              color="#F5A852"
              fontWeight={500}
              //   px={{ md: '5rem' }}
              px={
                index === 0
                  ? { base: '3rem', md: '5rem' }
                  : index === 1
                  ? { base: '8rem', md: '6rem' }
                  : { base: '1rem', md: '0rem' }
              }
              fontSize={{ base: '22px' }}
              lineHeight={{ base: '26px' }}
              fontFamily="FedraSansStd-medium"
              textAlign="center"
            >
              {card.title}
            </Text>
            <Text
              color="#FFFFFF"
              fontWeight="400"
              fontSize="1rem"
              lineHeight="26px"
              fontFamily="FedraSansStd-book"
              textAlign="center"
            >
              {
                card.description?.value?.document?.children[0]?.children[0]
                  ?.value
              }
            </Text>
          </Flex>
        ))}
      </Flex>
    </Box>
  );
};

export default HowItWorks;
